import React, { useState } from "react"
import { useField, useFormikContext } from "formik"
import { TFormValues } from "../../types"
import {
  yesNo,
  states,
  AboriginalOrTorresStrait,
  Concerns,
  Outcomes,
  applyingOnBehalfOf,
  partyType,
  tellUsMoreOptions,
  indivdualOrganisation,
  methodOfContact,
  courtOrProtesting
} from "../../config/questionOptions"

import { GuideContext } from "../../../../components/GatewayForm/GatewayForm.store"

import Button from "../../../Button/Button"
import { AccordionItem, Accordion } from "../../../Accordion/Accordion"

// TODO: Fill out with Proper Content from Form

const SummaryItem = ({ question, answer }: { question?: string; answer?: string }) => {
  return (
    <div
      style={{
        marginTop: "26px",
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        flexWrap: "wrap"
      }}
    >
      <p style={{ fontWeight: "bold", maxWidth: "177px" }}>{question}</p>
      <p style={{ width: "270px" }}>{answer}</p>
    </div>
  )
}

const ProtestReview: React.FC<{}> = () => {
  const { setCurrentStep } = React.useContext(GuideContext)
  const { values } = useFormikContext<TFormValues>()

  return (
    <Accordion>
      <AccordionItem heading="Step 1: Location">
        <SummaryItem
          question="Where is the concern occurring?"
          answer={states.find((state) => state.value === values.location)?.label}
        />
        <Button
          style={{ maxWidth: "max-content", marginTop: "26px" }}
          text="Edit this step"
          variant="secondary"
          onClick={() => {
            setCurrentStep("legal-step-two")
          }}
        />
      </AccordionItem>
      <AccordionItem heading="Step 2: About you">
        <SummaryItem
          question="Do you prefer to speak in a language other than English?"
          answer={yesNo.find((option) => option.value === values.languageOtherThanEng)?.label}
        />
        {values.languageOtherThanEng === "yes" && (
          <SummaryItem question="Please specify your preferred language" answer={values.language} />
        )}
        <SummaryItem
          question="Do you identify as a First Nations person?"
          answer={
            AboriginalOrTorresStrait.find((option) => option.value === values.aboriginalOrTorresStrait)?.label
          }
        />
        <Button
          style={{ maxWidth: "max-content", marginTop: "26px" }}
          text="Edit this step"
          variant="secondary"
          onClick={() => {
            setCurrentStep("legal-step-three")
          }}
        />
      </AccordionItem>
      <AccordionItem heading="Step 3: Main concern">
        <SummaryItem
          question="How would you describe your main concern?"
          answer={Concerns.find((option) => option.value === values.concern)?.label}
        />
        <Button
          style={{ maxWidth: "max-content", marginTop: "26px" }}
          text="Edit this step"
          variant="secondary"
          onClick={() => {
            setCurrentStep("legal-step-five")
          }}
        />
      </AccordionItem>
      <AccordionItem heading="Court or Protesting">
        <SummaryItem
          question="Court or Protesting?"
          answer={courtOrProtesting.find((item) => item.value === values.courtOrProtesting)?.label}
        />
        <Button
          style={{ maxWidth: "max-content", marginTop: "26px" }}
          text="Edit this step"
          variant="secondary"
          onClick={() => {
            setCurrentStep("protesting-step-one")
          }}
        />
      </AccordionItem>
      <AccordionItem heading="Protest description">
        <SummaryItem question="What help do you need?" answer={values.protestDescription} />
        <Button
          style={{ maxWidth: "max-content", marginTop: "26px" }}
          text="Edit this step"
          variant="secondary"
          onClick={() => {
            setCurrentStep("protesting-step-two")
          }}
        />
      </AccordionItem>
      <AccordionItem heading="Contact details">
        <SummaryItem
          question="Individual or Organisation"
          answer={indivdualOrganisation.find((item) => item.value === values.individualOrOrganisation)?.label}
        />
        {values.individualOrOrganisation === "organisation" ? (
          <SummaryItem question="Organisation Name" answer={values.organisationName} />
        ) : null}
        <SummaryItem question="Given name" answer={values.contactFirstName} />
        <SummaryItem question="Family name" answer={values.contactLastName} />
        <SummaryItem question="Email" answer={values.contactEmail} />
        <SummaryItem
          question="Date of birth"
          answer={new Date(values.contactBirthDate).toLocaleDateString("en-AU")}
        />
        <SummaryItem question="Contact Number" answer={values.contactNumber} />
        {values.contactAddress ? (
          <SummaryItem question="Street address" answer={values.contactAddress?.label} />
        ) : null}
        <SummaryItem
          question="Preferred method of contact"
          answer={methodOfContact.find((item) => item.value === values.preferredContactMethod)?.label}
        />
        <Button
          style={{ maxWidth: "max-content", marginTop: "26px" }}
          text="Edit this step"
          variant="secondary"
          onClick={() => {
            setCurrentStep("protesting-step-three")
          }}
        />
      </AccordionItem>
      {values.individualOrOrganisation === "individual" && (
        <AccordionItem heading="More about you">
          <SummaryItem
            question="Do any of the following apply to you?"
            answer={values.tellUsMore.map(
              (item, index) =>
                `${index > 0 ? ", " : ""}${tellUsMoreOptions.find((option) => option.value === item)?.label}`
            )}
          />
          <Button
            style={{ maxWidth: "max-content", marginTop: "26px" }}
            text="Edit this step"
            variant="secondary"
            onClick={() => {
              setCurrentStep("protesting-step-four")
            }}
          />
        </AccordionItem>
      )}
    </Accordion>
  )
}
export default ProtestReview
